import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { connect } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import Breadcrumbs from 'components/breadcrumb';
import Layout from '_metronic/layout/Layout';
import { Portlet, PortletBody } from 'components/partials/content/Portlet';
import PorletHeader, { PorletHeaderTitle } from 'components/porletHeader';
import Button from '@material-ui/core/Button';

import get from 'lodash/get';

import {
  requests as editProjectsRequests,
  actions as editProjectsActions,
} from 'redux/arqFinishes/editProject/reducer';

import { getProjectData } from 'redux/arqFinishes/editProject/selector';

import Client from './client';

import Project from './project';
import Status from './status';
import Shhets from './sheets';
import Installer from './installer';
import Warranty from './warranty';
import { toast } from 'react-toastify';
import toastConfig from 'enums/toast';

const breadcrumb = [
  { page: 'installer/arqFinishes', title: '3M™ Glass Finishes' },
  { page: 'installer/arqFinishes', title: 'Proyectos registrados' },
];

export const ViewProject = ({
  getProject,
  clearData,
  projectData,
  isLoading,
  hasError,
}) => {
  const { code } = useParams();
  const history = useHistory();

  useEffect(() => {
    getProject({ code });
    return () => clearData();
  }, [clearData, getProject, code]);

  useEffect(() => {
    if (!isLoading && hasError) {
      toast.error(
        <FormattedMessage id="Se a producido un error, vuelva a intentar" />,
        toastConfig,
      );
    }
  }, [isLoading, hasError]);

  useEffect(() => {
    if (Boolean(Object.keys(projectData).length)) {
      if (get(projectData, 'type', '') === 'AUTO') {
        history.push(`/installer/car/edit/${code}`);
      }
    }
  }, [history, projectData, code]);

  return (
    <Layout>
      <div className="kt-space-20" />
      <div className="row">
        <div className="col-12">
          <div className="kt-space-20" />
          <Breadcrumbs title="3M™ Glass Finishes" items={breadcrumb} />
          <div className="kt-space-20" />
        </div>
      </div>

      {Boolean(Object.keys(projectData).length) && (
        <div className="ViewProjectForm">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-6">
              <Portlet className="kt-portlet">
                <PorletHeader>
                  <PorletHeaderTitle variant="h4">
                    <FormattedMessage id="Cliente" />
                  </PorletHeaderTitle>
                </PorletHeader>
                <PortletBody>
                  <Client
                    values={projectData}
                    code={code}
                    companyName={get(projectData, 'data.companyName', '')}
                  />
                </PortletBody>
              </Portlet>
              {projectData.subtype !== 'FasaraSmall' && (
                <Portlet className="kt-portlet">
                  <PorletHeader>
                    <PorletHeaderTitle variant="h4">
                      <FormattedMessage id="Instalador" />
                    </PorletHeaderTitle>
                  </PorletHeader>
                  <PortletBody>
                    <Installer values={projectData} />
                  </PortletBody>
                </Portlet>
              )}
              <Portlet className="kt-portlet">
                <PorletHeader>
                  <PorletHeaderTitle variant="h4">
                    <FormattedMessage id="Películas" />
                  </PorletHeaderTitle>
                </PorletHeader>
                <PortletBody>
                  <Shhets values={projectData} />
                </PortletBody>
              </Portlet>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6">
              <Portlet className="kt-portlet">
                <PorletHeader>
                  <PorletHeaderTitle variant="h4">
                    <FormattedMessage id="Proyecto" />
                  </PorletHeaderTitle>
                </PorletHeader>
                <PortletBody>
                  <Project values={projectData} />
                </PortletBody>
              </Portlet>
              {projectData.subtype == 'FasaraSmall' && (
                <Portlet className="kt-portlet">
                  <PorletHeader>
                    <PorletHeaderTitle variant="h4">
                      <FormattedMessage id="Colocación" />
                    </PorletHeaderTitle>
                  </PorletHeader>
                  <PortletBody>
                    <Installer values={projectData} />
                  </PortletBody>
                </Portlet>
              )}
              <Portlet className="kt-portlet">
                <PorletHeader>
                  <PorletHeaderTitle variant="h4">
                    <FormattedMessage id="Garantía" />
                  </PorletHeaderTitle>
                </PorletHeader>
                <PortletBody>
                  <Warranty values={projectData} />
                </PortletBody>
              </Portlet>
              {projectData.subtype == 'Fasara' && (
                <Portlet className="kt-portlet">
                  <PorletHeader>
                    <PorletHeaderTitle variant="h4">
                      <FormattedMessage id="Etapa" />
                    </PorletHeaderTitle>
                  </PorletHeader>
                  <PortletBody>
                    <Status values={projectData} />
                  </PortletBody>
                </Portlet>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <Portlet className="kt-portlet--height-fluid">
                <PortletBody className="submit-bottons">
                  <Button variant="outlined" onClick={() => history.goBack()}>
                    <FormattedMessage id="Volver" />
                  </Button>
                </PortletBody>
              </Portlet>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export const mapDispatchToProps = (dispatch) => ({
  getProject: (data) => dispatch(editProjectsRequests.fetch(data)),
  clearData: () => dispatch(editProjectsActions.clearData()),
});

export default connect(
  (state) => ({
    ...getProjectData(state),
  }),
  mapDispatchToProps,
)(ViewProject);
